import React, { Component } from 'react'
import { slugify } from '../../../util'
import { ParseTenantInfo } from './utils/ParseTenantInfo'
import { RenderTenantList } from './utils/RenderTenantList'

export default class ComplianceMissingInfo extends Component {
  constructor(props) {
    super(props)

    this.state = {
      render: false,
    }
    this.requirements = {
      missingInfo: [],
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { render } = nextState
    if (render) {
      return true
    }

    this.setState({ render: true })
    return false
  }

  addIssueMessage = (acronym, messages, msg) => {
    messages.push(
      <li key={`${acronym}_${slugify(msg)}`} className="_wb-list__item">
        {msg}
      </li>,
    )
  }

  render = () => {
    const { allTenants } = this.props
    const { render } = this.state

    render &&
      Object.keys(allTenants).forEach((acronym) => {
        const tenant = allTenants[acronym]
        const messages = []

        if (tenant.status === 'active') {
          if (!tenant.planningItId)
            this.addIssueMessage(acronym, messages, 'Missing planningIT ID')
          if (!tenant.icto)
            this.addIssueMessage(acronym, messages, 'Missing ICTO')
          if (!tenant.confidentiality || tenant.confidentiality === 'unknown')
            this.addIssueMessage(acronym, messages, 'Missing Confidentiality')
          if (!tenant.integrity || tenant.integrity === 'unknown')
            this.addIssueMessage(acronym, messages, 'Missing Integrity')
          if (!tenant.availability || tenant.availability === 'unknown')
            this.addIssueMessage(acronym, messages, 'Missing Availability')
          if (!tenant.continuity || tenant.continuity === 'unknown')
            this.addIssueMessage(acronym, messages, 'Missing Continuity')
          if (!tenant.personalData || tenant.personalData === 'unknown')
            this.addIssueMessage(acronym, messages, 'Missing Personal Data')

          if (messages.length) {
            const row = ParseTenantInfo(tenant)
            row.messages = messages
            this.requirements.missingInfo.push(row)
          }
        }
      })

    if (!render || (allTenants && Object.keys(allTenants).length === 0)) {
      return (
        <div className="page-body__section">
          <div className="loader-container">
            <wb-spinner mode="dark" />
          </div>
        </div>
      )
    }

    return (
      <div className="page-body__section">
        <h3 className="wb-type-heading-m page-body__margin-bottom-s">
          Tenants with missing compliance info
        </h3>

        <wb-accordion theme="light" prevent-mobile-flyout>
          <RenderTenantList
            title="Missing Data"
            list={this.requirements.missingInfo}
          />
        </wb-accordion>
      </div>
    )
  }
}
